<template>
  <Accordion
    :class="[
      'filter-category border rounded',
      {
        'border-alto': !hasDescription,
        'bg-black-squeeze border-deep-cerulean': hasDescription,
        'bg-alabaster': open && !hasDescription,
        'hover:bg-alabaster': !open && !hasDescription
      }
    ]"
    :open="open"
  >
    <template #button>
      <FilterCategoryButton
        :name="name"
        :open="open"
        :description="description"
        @clear="onClear"
        @toggle="onToggle"
      />
    </template>

    <template #content>
      <div class="flex px-3 py-2 justify-between">
        <div class="flex flex-col">
          <DateUsedSelector
            :selectedOption="dateUsedOption"
            @select="onDateUsedSelect"
          />
          <DateRangePresets
            class="pt-3"
            @select="updateDates"
            @select-after="onPresetSelectAfter"
            @select-before="onPresetSelectBefore"
          />
        </div>
        <DateRangePicker
          class="bg-white rounded mt-1 pt-3"
          :dates="dates"
          :ref="dateRangePickerId"
          @pick="onDateRangePick"
        />
      </div>
    </template>
  </Accordion>
</template>

<script>
import {
  Accordion,
  DateRangePicker,
  DateRangePresets,
  DateUsedSelector,
  DATE_USED_OPTIONS
} from '@listen360/alexandria'
import { mapGetters, mapActions } from 'vuex'
import FilterCategoryButton from '@/components/FiltersPanel/FilterCategoryButton'
import { format } from 'date-fns'

export default {
  name: 'DateFilterCategory',
  components: {
    Accordion,
    DateRangePicker,
    DateRangePresets,
    DateUsedSelector,
    FilterCategoryButton
  },
  props: {
    id: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      name: 'Date Range',
      dateRangePickerId: 'date-range-picker',
      dateUsedOption: DATE_USED_OPTIONS.SURVEY_COMPLETION
    }
  },
  mounted() {
    if (this.dates.length && this.$refs[this.dateRangePickerId]) {
      this.updateDates(this.dates)
    }
  },
  computed: {
    ...mapGetters({
      dates: 'reports/appliedDateRange'
    }),
    hasDescription() {
      return Boolean(this.description)
    },
    description() {
      return this.dates[0] && this.dates[1]
        ? `${format(this.dates[0], 'MM/dd/yyyy')}-${format(
            this.dates[1],
            'MM/dd/yyyy'
          )}`
        : ''
    }
  },
  methods: {
    ...mapActions({
      setDates: 'reports/setAppliedDateRange',
      clearDates: 'reports/clearAppliedDateRange'
    }),
    onClear() {
      this.clearDates()
      if (this.$refs[this.dateRangePickerId]) {
        this.updateDates([])
      }
    },
    onToggle() {
      this.$emit('toggle', this.id)
    },
    onDateRangePick(dates) {
      this.setDates(dates)
    },
    onDateUsedSelect(id) {
      this.dateUsedOption = id
    },
    onPresetSelectAfter(dates) {
      this.setDates(dates)
      this.$refs[this.dateRangePickerId].focusStartDate()
    },
    onPresetSelectBefore(dates) {
      this.setDates(dates)
      this.$refs[this.dateRangePickerId].focusEndDate()
    },
    updateDates(dates) {
      this.setDates(dates)
    }
  }
}
</script>
